import { Identifiable, Constraint, Project, Id } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveConstraint(httpClient: HttpClient) {
  return (constraint: Constraint, project: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<
        Identifiable<Constraint> & {
          modifiedElements?: {
            tasks?: { uuid: Id; endDate: string; startDate: string }[];
            activities?: { uuid: Id; endDate: string; startDate: string }[];
            milestones?: { uuid: Id; endDate: string; startDate: string }[];
          };
        }
      >({
        endpoint: "/constraints",
        method: HttpMethods.POST,
        data: { ...constraint, project: `projects/${project.uuid}` },
      })
      .then((savedConstraint) => ({
        ...savedConstraint,
        impactedElements: (!!savedConstraint.modifiedElements
          ? [
              ...(savedConstraint.modifiedElements.tasks || []).map((t) => ({
                ...t,
                type: "task",
              })),
              ...(savedConstraint.modifiedElements.activities || []).map(
                (t) => ({
                  ...t,
                  type: "list",
                }),
              ),
              ...(savedConstraint.modifiedElements.milestones || []).map(
                (t) => ({
                  ...t,
                  type: "milestone",
                }),
              ),
            ]
          : []) as {
          type: "task" | "list" | "milestone";
          uuid: Id;
          endDate: string;
          startDate: string;
        }[],
      }));
}
export { saveConstraint };
